import React, { useEffect, useState } from "react";
import {
    Grid2 as Grid,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Box,
    Snackbar,
    SnackbarContent,
    IconButton,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateUser } from "../services/profileService";
import CloseIcon from "@mui/icons-material/Close";
import Toast from "../components/Toast"

const ProfilePage = () => {
    let user = sessionStorage.getItem('user');
    const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [severity, setSeverity] = useState('success'); // success or error

    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            number: "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Name is required"),
            email: Yup.string().email("Invalid email format").required("Email is required"),
            number: Yup.string()
                .matches(/^(?:\+44|0)7\d{9}$/, "Invalid UK mobile number")
                .required("Phone number is required"),
        }),
        onSubmit: (values) => {
            updateUser(JSON.parse(user)._id, values)
                .then((res) => {
                    const { id, ...rest } = res.user;
                    const updatedUser = {
                        ...rest,
                        _id: id,
                    };
                    sessionStorage.setItem('user', JSON.stringify(updatedUser));
                    setToastMessage('Profile updated successfully!');
                    setSeverity('success');
                    setOpenToast(true);
                })
                .catch((err) => {
                    setToastMessage('Failed to update profile!');
                    setSeverity('error');
                    setOpenToast(true);
                    console.error(err);
                });
        },
    });

    useEffect(() => {
        formik.setValues(JSON?.parse(user));
    }, [user]);

    const handleToastClose = () => {
        setOpenToast(false);
    };

    return (
        <Box
            padding={4}
            sx={{
                marginTop: "80px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "50vh",
                backgroundColor: "#f4f7fb"
            }}
        >
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} md={6}>
                    <Card sx={{
                        borderRadius: 4,
                        boxShadow: 3,
                        backgroundColor: "#ffffff",
                        padding: 4
                    }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom align="center" sx={{
                                color: "#10374A",
                                fontWeight: "bold",
                            }}>
                                Profile Settings
                            </Typography>
                            <form onSubmit={formik.handleSubmit}>
                                <TextField
                                    fullWidth
                                    name="name"
                                    placeholder="Name"
                                    variant="outlined"
                                    margin="normal"
                                    value={formik.values?.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.name && Boolean(formik.errors.name)}
                                    helperText={formik.touched.name && formik.errors.name}
                                    sx={{
                                        marginBottom: 2,
                                        backgroundColor: "#fafafa",
                                        borderRadius: 1
                                    }}
                                />
                                <TextField
                                    fullWidth
                                    name="email"
                                    placeholder="Email"
                                    variant="outlined"
                                    margin="normal"
                                    value={formik.values?.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                    sx={{
                                        marginBottom: 2,
                                        backgroundColor: "#fafafa",
                                        borderRadius: 1
                                    }}
                                />
                                <TextField
                                    fullWidth
                                    name="number"
                                    placeholder="Phone Number"
                                    variant="outlined"
                                    margin="normal"
                                    value={formik.values?.number}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.number && Boolean(formik.errors.number)}
                                    helperText={formik.touched.number && formik.errors.number}
                                    sx={{
                                        marginBottom: 2,
                                        backgroundColor: "#fafafa",
                                        borderRadius: 1
                                    }}
                                />
                                <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                        backgroundColor: "#10374A",
                                        color: "#FFFFFF",
                                        "&:hover": {
                                            backgroundColor: "#08293D",
                                        },
                                        padding: "10px 20px",
                                        borderRadius: 3,
                                    }}
                                    type="submit">
                                    Save
                                </Button>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Toast
        open={openToast}
        severity={severity}
        message={toastMessage}
        onClose={() => setOpenToast(false)}
      />
        </Box>
    );
};

export default ProfilePage;
